// Highcharts plugin to hook LegendSorter
(function (H) {
  if (!H) {
    return;
  }
  H.wrap(H.Legend.prototype, 'render', function (proceed) {
    proceed.call(this);
    new LegendSorter(this.chart);
  });
}(Highcharts));

export default class LegendSorter {
  constructor(chart) {
    this.chart = chart;

    // Cache DOM and initialize values
    this.$legendContainer = $(this.chart.container).find('.highcharts-legend').filter('div');
    this.$legendItems = this.$legendContainer.find('.highcharts-legend-item').parent();
    this.$bigLegendItems = this.$legendItems.find('.c-chart-legend__item--big').parents('.highcharts-legend-item');

    // Sort big legend items first
    $(this.$bigLegendItems.get().reverse())
      .css({float: 'left'})
      .prependTo(this.$legendItems);
  }
}



/** WEBPACK FOOTER **
 ** ./src/common/analyticsPanel/legendSorter.js
 **/